/**
 * 验证手机号， 身份证号， 验证码， 银行卡（只验证是否为空）
 * @description phone, idCard, captcha, bankCard
 */


export const validatePhone = (val) => {
    let _resReg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(val);
    if (val === '') {
      return "请输入手机号"
    }

    if(!_resReg) {
      return "您输入的手机号码格式不正确"
    }
  }

export const validateBankCard = (val) => {
    if (val === '') {
      return "请输入银行卡号"
    }
  }

export const validateCaptcha = (val) => {
    let _resReg = /^\d{6}$/.test(val);

    if (val === '') {
      return "请输入验证码"
    }

    if(!_resReg) {
      return "您输入的验证码格式不正确"
    }
  }

 export const validateIdCard = (val) => {
    let _resReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(val);

    if (val === '') {
      return "请输入身份证号"
    }

    if(!_resReg) {
      return "您输入的身份证号格式不正确"
    }
  } 


// WEBPACK FOOTER //
// ./src/plugins/validate.js